var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "newsSource", "data-role": "page" } }, [
    _c(
      "div",
      {
        staticClass: "newsSource-content",
        attrs: { "data-position": "fixed" }
      },
      [
        _c("div", { staticClass: "detailWrap" }, [
          _c("div", { staticClass: "top-area" }, [
            _c("div", [
              _c("img", {
                attrs: {
                  src:
                    " https://storage.googleapis.com/kingnetcare/CHK/committee/official/" +
                    _vm.offiec.legal_id +
                    "/logo.jpg",
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("h2", [_vm._v(_vm._s(_vm.offiec.name))]),
              _vm._v(" "),
              _c("div", { staticClass: "contactDiv" }, [
                _c("p", [_vm._v(_vm._s(_vm.offiec.address))]),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm.offiec.tel))])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "about-area" }, [
            _c("h3", [_vm._v("關於我們")]),
            _vm._v(" "),
            _c("div", { staticClass: "desc" }, [
              _c("p", { domProps: { innerHTML: _vm._s(_vm.offiec.content) } })
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _vm.offiec.multiLink.length > 0
      ? _c("div", { staticClass: "qk-link" }, [
          _c(
            "div",
            {
              class: {
                "qk-link-wrap-col1": _vm.offiec.multiLink.length == 1,
                "qk-link-wrap-col2": _vm.offiec.multiLink.length == 2,
                "qk-link-wrap-col3": _vm.offiec.multiLink.length == 3
              }
            },
            _vm._l(_vm.offiec.multiLink, function(LinkBtn, LinkBtn_ind) {
              return _c(
                "div",
                {
                  key: LinkBtn_ind,
                  on: {
                    click: function($event) {
                      _vm.windowsOpen(LinkBtn.link)
                    }
                  }
                },
                [_c("span", [_vm._v(_vm._s(LinkBtn.name))])]
              )
            })
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3cea9484", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cea9484","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/newsSource.vue
// module id = null
// module chunks = 